<template>
    <nav class="navbar navbar-expand-md resumeNavbar py-4">
        <div class="container">
            <router-link class="navbar-brand" to="/"
                >
                CV Maker
            </router-link>
            <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                    <li class="nav-item">
                        <router-link class="nav-link" to="/">Tools</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/"
                            >Pricing</router-link
                        >
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/">FAQ</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link nav-btn" to="/"
                            >Login</router-link
                        >
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link nav-btn nav-btn2" to="/resume"
                            >Get Started</router-link
                        >
                    </li>
                </ul>
            </div>
        </div>
    </nav>

    <Section class="hero-section">
        <div class="container">
            <div class="text-wrapper">
                <h1>
                    Elevate the search for your
                    <span
                        >next career<svg
                            width="345"
                            height="21"
                            viewBox="0 0 345 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M146.392 2.69737C130.274 3.34391 114.345 4.1389 98.811 5.00802C76.8215 6.23751 54.8406 7.50941 32.9922 9.52324C26.1147 10.1592 19.1307 10.5619 12.2963 11.3569C8.00606 11.855 2.31734 12.565 1.57077 12.7134C1.18028 12.7982 1.00992 12.9255 0.954875 12.9679C0.567827 13.2647 0.638449 13.5508 0.856916 13.7733C0.944647 13.8687 1.16649 14.102 1.78233 14.1338C42.9677 16.3066 85.082 12.067 126.317 11.6218C197.826 10.8587 271.503 13.89 342.445 20.5039C343.064 20.5569 343.666 20.2918 343.752 19.8996C343.855 19.5181 343.408 19.1471 342.789 19.0941C271.727 12.4697 197.93 9.42773 126.283 10.2015C87.8532 10.6148 48.665 14.3352 10.1821 13.0633C11.0663 12.9573 11.9333 12.8513 12.7246 12.7559C19.5315 11.9609 26.4863 11.5688 33.3362 10.9329C55.1382 8.91904 77.0744 7.64715 99.0346 6.42826C126.283 4.90199 154.718 3.5877 183.377 2.97295C193.629 3.06834 203.847 3.16378 214.065 3.28037C236.17 3.53474 258.378 4.27668 280.431 5.273C287.071 5.58037 293.711 5.89832 300.351 6.17389C302.553 6.26928 308.23 6.54481 309.021 6.52361C310.002 6.50242 310.191 5.99371 310.208 5.90892C310.259 5.71813 310.225 5.45314 309.743 5.23056C309.692 5.19876 309.382 5.0927 308.694 5.02911C268.596 1.27704 225.78 0.651791 183.411 1.55271C138.72 1.16055 93.8568 0.990884 49.2792 0.810699C48.641 0.810699 48.1197 1.12872 48.1146 1.52088C48.1111 1.91305 48.6254 2.23108 49.2636 2.24168C81.5417 2.36887 113.983 2.49598 146.392 2.69737Z"
                                fill="#1D1D20"
                                stroke="black"
                                stroke-width="0.791457"
                            />
                        </svg>
                    </span>
                </h1>
                <p>
                    Our tools help you from creating a professional resume, and
                    sending your first letter to finding job listings and
                    keeping track of your applications.
                </p>
                <router-link to="/resume"
                    ><svg
                        width="248"
                        height="39"
                        viewBox="0 0 248 39"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M19.5 0C8.73045 0 0 8.73045 0 19.5C0 30.2696 8.73045 39 19.5 39H176.5C183.966 39 190.453 34.8038 193.729 28.641C194.989 26.2713 196.683 24.0609 199.105 22.9047C200.352 22.3091 201.718 22 203.1 22H210C211.657 22 213 20.6569 213 19C213 17.3431 211.657 16 210 16H203.216C201.757 16 200.317 15.6739 199.001 15.0456L198.864 14.9805C196.344 13.7774 194.525 11.5399 193.044 9.17229C189.598 3.6638 183.477 0 176.5 0H19.5Z"
                            fill="#4314B6"
                        />
                        <path
                            d="M14.6094 19.4058C14.6094 18.2102 14.8764 17.1422 15.4104 16.202C15.956 15.2501 16.6931 14.513 17.6217 13.9906C18.562 13.4567 19.6125 13.1897 20.7733 13.1897C22.1314 13.1897 23.3213 13.5379 24.3428 14.2344C25.3643 14.9309 26.0782 15.8943 26.4844 17.1248H23.6811C23.4025 16.5444 23.0078 16.1091 22.4971 15.8189C21.9979 15.5287 21.4175 15.3836 20.7559 15.3836C20.0478 15.3836 19.4152 15.5519 18.858 15.8885C18.3124 16.2136 17.8829 16.6779 17.5695 17.2815C17.2677 17.8851 17.1168 18.5932 17.1168 19.4058C17.1168 20.2067 17.2677 20.9148 17.5695 21.5301C17.8829 22.1337 18.3124 22.6038 18.858 22.9404C19.4152 23.2655 20.0478 23.428 20.7559 23.428C21.4175 23.428 21.9979 23.2829 22.4971 22.9927C23.0078 22.6909 23.4025 22.2497 23.6811 21.6693H26.4844C26.0782 22.9114 25.3643 23.8807 24.3428 24.5772C23.3329 25.262 22.143 25.6045 20.7733 25.6045C19.6125 25.6045 18.562 25.3433 17.6217 24.8209C16.6931 24.287 15.956 23.5498 15.4104 22.6096C14.8764 21.6693 14.6094 20.6014 14.6094 19.4058ZM31.0042 17.3512C31.3177 16.8404 31.7239 16.4399 32.2231 16.1497C32.7338 15.8595 33.3142 15.7144 33.9643 15.7144V18.274H33.32C32.5539 18.274 31.9735 18.4539 31.5788 18.8138C31.1958 19.1736 31.0042 19.8005 31.0042 20.6943V25.5H28.5665V15.8537H31.0042V17.3512ZM44.5734 20.4679C44.5734 20.8162 44.5502 21.1296 44.5038 21.4082H37.4519C37.5099 22.1046 37.7537 22.6502 38.1832 23.0449C38.6127 23.4396 39.1408 23.6369 39.7677 23.6369C40.6731 23.6369 41.3173 23.248 41.7004 22.4703H44.3296C44.051 23.3989 43.5171 24.1651 42.7277 24.7687C41.9384 25.3607 40.9691 25.6567 39.8199 25.6567C38.8913 25.6567 38.0555 25.4536 37.3126 25.0473C36.5813 24.6294 36.0067 24.0432 35.5888 23.2887C35.1825 22.5341 34.9794 21.6635 34.9794 20.6769C34.9794 19.6786 35.1825 18.8022 35.5888 18.0476C35.9951 17.2931 36.5639 16.7127 37.2952 16.3064C38.0265 15.9002 38.8681 15.697 39.8199 15.697C40.7369 15.697 41.5553 15.8943 42.275 16.289C43.0063 16.6837 43.5693 17.2467 43.964 17.978C44.3703 18.6977 44.5734 19.5277 44.5734 20.4679ZM42.0487 19.7714C42.037 19.1446 41.8107 18.6455 41.3696 18.274C40.9285 17.8909 40.3887 17.6994 39.7503 17.6994C39.1466 17.6994 38.6359 17.8851 38.218 18.2566C37.8117 18.6164 37.5621 19.1214 37.4693 19.7714H42.0487ZM45.7259 20.642C45.7259 19.667 45.9174 18.8022 46.3005 18.0476C46.6951 17.2931 47.2233 16.7127 47.885 16.3064C48.5582 15.9002 49.3069 15.697 50.1311 15.697C50.8508 15.697 51.4776 15.8421 52.0116 16.1323C52.5572 16.4225 52.9925 16.7882 53.3175 17.2293V15.8537H55.7726V25.5H53.3175V24.0896C53.0041 24.5423 52.5688 24.9196 52.0116 25.2214C51.466 25.5116 50.8334 25.6567 50.1137 25.6567C49.3011 25.6567 48.5582 25.4478 47.885 25.0299C47.2233 24.612 46.6951 24.0258 46.3005 23.2713C45.9174 22.5051 45.7259 21.6287 45.7259 20.642ZM53.3175 20.6769C53.3175 20.0848 53.2014 19.5799 52.9693 19.162C52.7371 18.7325 52.4237 18.4075 52.029 18.1869C51.6344 17.9548 51.2107 17.8387 50.7579 17.8387C50.3052 17.8387 49.8873 17.949 49.5043 18.1695C49.1212 18.3901 48.8078 18.7151 48.564 19.1446C48.3319 19.5625 48.2158 20.0616 48.2158 20.642C48.2158 21.2224 48.3319 21.7332 48.564 22.1743C48.8078 22.6038 49.1212 22.9346 49.5043 23.1668C49.899 23.3989 50.3168 23.515 50.7579 23.515C51.2107 23.515 51.6344 23.4047 52.029 23.1842C52.4237 22.952 52.7371 22.627 52.9693 22.2091C53.2014 21.7796 53.3175 21.2689 53.3175 20.6769ZM60.9916 17.8561V22.5225C60.9916 22.8476 61.0671 23.0855 61.218 23.2364C61.3805 23.3757 61.6475 23.4454 62.0189 23.4454H63.1507V25.5H61.6184C59.5638 25.5 58.5365 24.5017 58.5365 22.5051V17.8561H57.3873V15.8537H58.5365V13.4683H60.9916V15.8537H63.1507V17.8561H60.9916ZM73.8712 20.4679C73.8712 20.8162 73.848 21.1296 73.8016 21.4082H66.7497C66.8077 22.1046 67.0515 22.6502 67.481 23.0449C67.9105 23.4396 68.4387 23.6369 69.0655 23.6369C69.9709 23.6369 70.6152 23.248 70.9982 22.4703H73.6275C73.3489 23.3989 72.8149 24.1651 72.0256 24.7687C71.2362 25.3607 70.2669 25.6567 69.1177 25.6567C68.1891 25.6567 67.3533 25.4536 66.6104 25.0473C65.8791 24.6294 65.3045 24.0432 64.8866 23.2887C64.4803 22.5341 64.2772 21.6635 64.2772 20.6769C64.2772 19.6786 64.4803 18.8022 64.8866 18.0476C65.2929 17.2931 65.8617 16.7127 66.593 16.3064C67.3243 15.9002 68.1659 15.697 69.1177 15.697C70.0348 15.697 70.8531 15.8943 71.5728 16.289C72.3041 16.6837 72.8671 17.2467 73.2618 17.978C73.6681 18.6977 73.8712 19.5277 73.8712 20.4679ZM71.3465 19.7714C71.3349 19.1446 71.1085 18.6455 70.6674 18.274C70.2263 17.8909 69.6865 17.6994 69.0481 17.6994C68.4445 17.6994 67.9337 17.8851 67.5158 18.2566C67.1096 18.6164 66.86 19.1214 66.7671 19.7714H71.3465ZM93.0501 13.3464V25.5H90.6124V17.5949L87.3563 25.5H85.5106L82.2372 17.5949V25.5H79.7995V13.3464H82.568L86.4335 22.3832L90.299 13.3464H93.0501ZM104.689 15.8537L98.7162 30.062H96.1218L98.2113 25.2562L94.3458 15.8537H97.0795L99.5694 22.5922L102.094 15.8537H104.689ZM116.42 25.5L113.738 20.7639H112.589V25.5H110.152V13.3464H114.714C115.654 13.3464 116.455 13.5147 117.116 13.8513C117.778 14.1764 118.271 14.6233 118.596 15.1921C118.933 15.7492 119.101 16.3761 119.101 17.0726C119.101 17.8735 118.869 18.599 118.405 19.2491C117.941 19.8875 117.25 20.3286 116.333 20.5724L119.241 25.5H116.42ZM112.589 18.9357H114.626C115.288 18.9357 115.781 18.7789 116.106 18.4655C116.432 18.1405 116.594 17.6936 116.594 17.1248C116.594 16.5676 116.432 16.1381 116.106 15.8363C115.781 15.5229 115.288 15.3662 114.626 15.3662H112.589V18.9357ZM130.273 20.4679C130.273 20.8162 130.25 21.1296 130.204 21.4082H123.152C123.21 22.1046 123.454 22.6502 123.883 23.0449C124.313 23.4396 124.841 23.6369 125.468 23.6369C126.373 23.6369 127.017 23.248 127.4 22.4703H130.03C129.751 23.3989 129.217 24.1651 128.428 24.7687C127.638 25.3607 126.669 25.6567 125.52 25.6567C124.591 25.6567 123.755 25.4536 123.013 25.0473C122.281 24.6294 121.707 24.0432 121.289 23.2887C120.882 22.5341 120.679 21.6635 120.679 20.6769C120.679 19.6786 120.882 18.8022 121.289 18.0476C121.695 17.2931 122.264 16.7127 122.995 16.3064C123.726 15.9002 124.568 15.697 125.52 15.697C126.437 15.697 127.255 15.8943 127.975 16.289C128.706 16.6837 129.269 17.2467 129.664 17.978C130.07 18.6977 130.273 19.5277 130.273 20.4679ZM127.749 19.7714C127.737 19.1446 127.511 18.6455 127.07 18.274C126.628 17.8909 126.089 17.6994 125.45 17.6994C124.847 17.6994 124.336 17.8851 123.918 18.2566C123.512 18.6164 123.262 19.1214 123.169 19.7714H127.749ZM135.744 25.6567C134.955 25.6567 134.247 25.5174 133.62 25.2388C132.993 24.9486 132.494 24.5597 132.122 24.0722C131.762 23.5847 131.565 23.0449 131.53 22.4529H133.985C134.032 22.8243 134.212 23.132 134.525 23.3757C134.85 23.6195 135.251 23.7414 135.727 23.7414C136.191 23.7414 136.551 23.6485 136.806 23.4628C137.073 23.2771 137.207 23.0391 137.207 22.7489C137.207 22.4355 137.044 22.2033 136.719 22.0524C136.406 21.8899 135.901 21.7158 135.204 21.5301C134.485 21.3559 133.893 21.176 133.428 20.9903C132.976 20.8045 132.581 20.5202 132.244 20.1371C131.919 19.754 131.757 19.2375 131.757 18.5874C131.757 18.0534 131.908 17.5659 132.209 17.1248C132.523 16.6837 132.964 16.3355 133.533 16.0801C134.113 15.8247 134.792 15.697 135.57 15.697C136.719 15.697 137.636 15.9872 138.321 16.5676C139.006 17.1364 139.383 17.9083 139.453 18.8834H137.12C137.085 18.5004 136.922 18.1985 136.632 17.978C136.353 17.7458 135.976 17.6297 135.5 17.6297C135.059 17.6297 134.717 17.711 134.473 17.8735C134.241 18.036 134.125 18.2624 134.125 18.5526C134.125 18.8776 134.287 19.1272 134.612 19.3013C134.937 19.4638 135.442 19.6321 136.127 19.8063C136.824 19.9804 137.398 20.1603 137.851 20.346C138.304 20.5318 138.692 20.822 139.017 21.2166C139.354 21.5997 139.528 22.1105 139.54 22.7489C139.54 23.3061 139.383 23.8052 139.07 24.2463C138.768 24.6874 138.327 25.0357 137.746 25.2911C137.178 25.5348 136.51 25.6567 135.744 25.6567ZM150.647 15.8537V25.5H148.192V24.2812C147.879 24.699 147.467 25.0299 146.956 25.2736C146.457 25.5058 145.911 25.6219 145.319 25.6219C144.565 25.6219 143.897 25.4652 143.317 25.1518C142.737 24.8267 142.278 24.3566 141.941 23.7414C141.616 23.1145 141.454 22.3716 141.454 21.5126V15.8537H143.892V21.1644C143.892 21.9305 144.083 22.5225 144.466 22.9404C144.849 23.3467 145.372 23.5498 146.033 23.5498C146.706 23.5498 147.235 23.3467 147.618 22.9404C148.001 22.5225 148.192 21.9305 148.192 21.1644V15.8537H150.647ZM165.032 15.7144C166.216 15.7144 167.168 16.0801 167.888 16.8114C168.619 17.5311 168.985 18.541 168.985 19.8411V25.5H166.547V20.1719C166.547 19.4174 166.355 18.8428 165.972 18.4481C165.589 18.0418 165.067 17.8387 164.405 17.8387C163.744 17.8387 163.215 18.0418 162.821 18.4481C162.438 18.8428 162.246 19.4174 162.246 20.1719V25.5H159.808V20.1719C159.808 19.4174 159.617 18.8428 159.234 18.4481C158.851 18.0418 158.328 17.8387 157.667 17.8387C156.993 17.8387 156.46 18.0418 156.065 18.4481C155.682 18.8428 155.49 19.4174 155.49 20.1719V25.5H153.053V15.8537H155.49V17.0203C155.804 16.614 156.204 16.2948 156.692 16.0627C157.191 15.8305 157.736 15.7144 158.328 15.7144C159.083 15.7144 159.756 15.8769 160.348 16.202C160.94 16.5154 161.399 16.9681 161.724 17.5601C162.037 17.0029 162.49 16.556 163.082 16.2194C163.686 15.8827 164.336 15.7144 165.032 15.7144ZM180.265 20.4679C180.265 20.8162 180.242 21.1296 180.195 21.4082H173.144C173.202 22.1046 173.445 22.6502 173.875 23.0449C174.304 23.4396 174.832 23.6369 175.459 23.6369C176.365 23.6369 177.009 23.248 177.392 22.4703H180.021C179.743 23.3989 179.209 24.1651 178.419 24.7687C177.63 25.3607 176.661 25.6567 175.512 25.6567C174.583 25.6567 173.747 25.4536 173.004 25.0473C172.273 24.6294 171.698 24.0432 171.28 23.2887C170.874 22.5341 170.671 21.6635 170.671 20.6769C170.671 19.6786 170.874 18.8022 171.28 18.0476C171.687 17.2931 172.256 16.7127 172.987 16.3064C173.718 15.9002 174.56 15.697 175.512 15.697C176.429 15.697 177.247 15.8943 177.967 16.289C178.698 16.6837 179.261 17.2467 179.656 17.978C180.062 18.6977 180.265 19.5277 180.265 20.4679ZM177.74 19.7714C177.729 19.1446 177.502 18.6455 177.061 18.274C176.62 17.8909 176.08 17.6994 175.442 17.6994C174.838 17.6994 174.328 17.8851 173.91 18.2566C173.503 18.6164 173.254 19.1214 173.161 19.7714H177.74Z"
                            fill="white"
                        />
                        <circle cx="228.5" cy="19.5" r="19.5" fill="#4314B6" />
                        <path
                            d="M221.293 25.2929C220.902 25.6834 220.902 26.3166 221.293 26.7071C221.683 27.0976 222.317 27.0976 222.707 26.7071L221.293 25.2929ZM237 12C237 11.4477 236.552 11 236 11L227 11C226.448 11 226 11.4477 226 12C226 12.5523 226.448 13 227 13L235 13L235 21C235 21.5523 235.448 22 236 22C236.552 22 237 21.5523 237 21L237 12ZM222.707 26.7071L236.707 12.7071L235.293 11.2929L221.293 25.2929L222.707 26.7071Z"
                            fill="white"
                        />
                    </svg>
                </router-link>
            </div>

            <div class="hero-img">
                <img
                    :src="require('@/assets/hero-image.png')"
                    alt="Hero Image"
                />
            </div></div
    ></Section>
</template>

<script>
export default {
    name: "HomePage",
};
</script>
<style lang="scss">
.resumeNavbar {
.navbar-toggler{border:0; &:focus{box-shadow:none}}
    .navbar-nav {
        display: flex;
        gap: 15px;
        a {
            font-family: "Poppins";
            font-weight: 500;
            font-size: 16px;
            color: #1d1d20;
        }
        .nav-btn {
            padding: 8px 25px;
            border: 1px solid #4314b6;
            border-radius: 34px;
            font-family: "Poppins";
            font-weight: 600;
            font-size: 14px;
            color: #1d1d20;
        }
        .nav-btn2 {
            background-color: #4314b6;
            color: #fff;
        }
    }
}

.hero-section {
    padding: 2rem 0;
    .text-wrapper {
        width: 628.42px;
        margin: auto;
        text-align: center;
        h1 {
            font-family: "Poppins";
            font-weight: 600;
            font-size: 59.2366px;
            text-align: center;
            color: #1d1d20;

            span {
                color: #4314b6;
                position: relative;

                svg {
                    position: absolute;
                    bottom: -10px;
                    left: 0px;
                }
            }
        }

        p {
            font-family: "Poppins";
            font-weight: 500;
            font-size: 16.6206px;
            text-align: center;
            color: #4c4c4f;
            margin-top: 26px;
        }
    }
    .hero-img {
        margin-top: 4rem;
        img {
            width: 100%;
        }
    }
}

/* Responsive Styles */

/* Tablets */
@media (max-width: 992px) {
    .resumeNavbar {
        .navbar-nav {
            gap: 15px;
            a {
                font-size: 14px;
            }
            .nav-btn {
                padding: 7px 22px;
                border-radius: 34px;
                font-size: 13px;
            }
        }
    }

    .hero-section {
        padding: 1rem 0;

        .text-wrapper {
            width: 350px;
            h1 {
                font-size: 2.125rem;

                span svg {
                    width: 200px;
                }
            }

            p {
                font-size: 13px;
            }

            svg {
                width: 200px;
            }
        }

        .hero-img {
            margin-top: 2rem;
        }
    }
}

/* Phones */
@media (max-width: 767px) {
    .resumeNavbar {
        .navbar-nav {
            gap: 10px;
            text-align:center;
            margin-top:1rem;
            a {
                font-size: 14px;
            }
            .nav-btn {
                padding: 7px 22px;
                border-radius: 34px;
                font-size: 13px;
            }
        }
    }

    .hero-section {
        padding: 1rem 0;

        .text-wrapper {
            width: 350px;
            h1 {
                font-size: 2.125rem;

                span svg {
                    width: 200px;
                }
            }

            p {
                font-size: 13px;
            }

            svg {
                width: 200px;
            }
        }

        .hero-img {
            margin-top: 2rem;
        }
    }
}

@media (max-width: 575px) {
  
    .hero-section {

        .text-wrapper {
            width: 100%;
            h1 {
                font-size: 1.75rem;

                span svg {
                    width: 160px;
                }
            }

            p {
                font-size: 13px;
                margin-top:1rem;
            }

            svg {
                width: 200px;
            }
        }

        .hero-img {
            margin-top: 2rem;
        }
    }
}
</style>
